import { NavigateFunction, NavigateOptions } from 'react-router-dom';
interface State {
  currentPage?: number;
  data?: unknown;
}

export default function redirectTo(url: string, navigate: NavigateFunction, state?: State, opts: NavigateOptions = {}) {
  const newOpts: NavigateOptions = { relative: 'path', ...opts };
  if (state) Object.assign(newOpts, { state });
  navigate(url, newOpts);
}
